import { HomeOutlined } from '@ant-design/icons'

import { RouteItem } from '@eastcoal/router/types/route'

export const homeRoute: RouteItem = {
  title: '首页',
  path: '/',
  icon: <HomeOutlined />,
  Component: () => import('./index')
}
